module.exports = __webpack_public_path__ + "assets/img/star_sentence_un10.27cc12b4.png";